module.exports = {"description":"","displayName":"H2","methods":[],"props":{"title":{"type":{"name":"string"},"required":false,"description":"Title text","defaultValue":{"value":"undefined","computed":true}},"role":{"type":{"name":"enum","value":[{"value":"'default'","computed":false},{"value":"'subtle'","computed":false},{"value":"'promoted'","computed":false},{"value":"'critical'","computed":false}]},"required":false,"description":"Role (style) to apply to heading","defaultValue":{"value":"'default'","computed":false}},"cssMap":{"defaultValue":{"value":"styles","computed":true},"required":false}}}


//////////////////
// WEBPACK FOOTER
// ./.lochness/props/H2-props.json
// module id = 432
// module chunks = 0